import { cloudfrontUrl } from "../config/config"
export interface Product {
    id: number;
    name: string;
    price: string;
    description: string;
    image: string;
    category: string;
    tags: string[];
}

export const initialProducts: Product[] = [
    {
        id: 1,
        name: "Ganesh Idol - 9 in",
        price: "₹875",
        description: "Premium handcrafted Ganesh Idol in a majestic 9-inch size. Perfect for your home altar or as a centerpiece for spiritual decor, bringing serenity and positive energy to your space.",
        image: `${cloudfrontUrl}/product-1.png`,
        category: "tableDecor",
        tags: ["Decorative", "Stylish"]
    },
    {
        id: 2,
        name: "Ganesh Idol - 6 in",
        price: "₹350",
        description: "Elegant 6-inch Ganesh Idol crafted with intricate details. An ideal spiritual addition to your work desk or car dashboard, symbolizing wisdom and new beginnings.",
        image: `${cloudfrontUrl}/product-3.jpg`,
        category: "tableDecor",
        tags: ["Decorative", "Stylish"]
    },
    {
        id: 3,
        name: "Ganesh Idol - 3 in",
        price: "₹150",
        description: "Charming 3-inch Ganesh figurine, perfectly sized for modern minimalist spaces. A thoughtful spiritual gift for loved ones or a subtle addition to your personal collection.",
        image: `${cloudfrontUrl}/product2.jpg`,
        category: "tableDecor",
        tags: ["Decorative", "Stylish"]
    },
    {
        id: 4,
        name: "Personalized Desk Lotus",
        price: "₹220",
        description: "A beautiful personalized desk lotus that combines artistic design with functionality. Customize it to make your workspace unique and vibrant with this nature-inspired decor.",
        image: `${cloudfrontUrl}/product4.jpg`,
        category: "tableDecor",
        tags: ["Decorative", "Stylish"]
    },
    {
        id: 5,
        name: "Star Tower",
        price: "₹119",
        description: "Modern geometric Star Tower designed to catch the light and add a futuristic touch to your desk. A compact yet impactful decorative piece for contemporary homes.",
        image: `${cloudfrontUrl}/product5.jpg`,
        category: "tableDecor",
        tags: ["Decorative", "Stylish"]
    },
    {
        id: 6,
        name: "FairyTale Glow Cottage",
        price: "₹175",
        description: "Whimsical FairyTale Cottage that brings a touch of magic to your tabletop. Intricately designed to simulate a glowing aesthetic, perfect for fantasy enthusiasts.",
        image: `${cloudfrontUrl}/product6.jpg`,
        category: "tableDecor",
        tags: ["Decorative", "Stylish"]
    },
    {
        id: 7,
        name: "Cat Pen Stand",
        price: "₹200",
        description: "Adorable and practical Cat-themed pen stand. Keep your stationery organized with this playful feline companion, adding personality to any study or office desk.",
        image: `${cloudfrontUrl}/product-7.png`,
        category: "penStand",
        tags: ["Desk Use", "Compact"]
    },
    {
        id: 8,
        name: "Pista Bowl",
        price: "₹430",
        description: "Sophisticated Pisata Bowl featuring a unique modern texture. Ideal for holding trinkets, keys, or simply serving as a minimalist decorative accent in your living room.",
        image: `${cloudfrontUrl}/product-8.png`,
        category: "tableDecor",
        tags: ["Decorative", "Stylish"]
    },
    {
        id: 9,
        name: "Harry Potter Coaster -1",
        price: "₹275",
        description: "Magical Harry Potter inspired coaster featuring iconic Wizarding World symbols. Protect your surfaces in style while celebrating your love for the legendary series.",
        image: `${cloudfrontUrl}/product-9.png`,
        category: "tableDecor",
        tags: ["Decorative", "Stylish"]
    },
    {
        id: 10,
        name: "Flower Design Bookmark Dual Color",
        price: "₹95",
        description: "Delicate flower stencil bookmark for book lovers. Its thin yet durable design ensures you never lose your page, adding a floral elegance to your reading experience.",
        image: `${cloudfrontUrl}/product-10.png`,
        category: "bookMark",
        tags: ["Light Weight", "Simple"]
    },
    {
        id: 11,
        name: "Fairy Bookmark Double Color",
        price: "₹90",
        description: "Vibrant double-color Fairy bookmark that stands out in any book. A magical gift for readers of all ages, blending artistic flair with practical utility.",
        image: `${cloudfrontUrl}/product-11.png`,
        category: "bookMark",
        tags: ["Light Weight", "Simple"]
    },
    {
        id: 12,
        name: "Face vase",
        price: "₹200",
        description: "Artistic Face Vase that doubles as a sculpture. A bold statement piece for your home that uniquely displays your favorite flowers or greenery.",
        image: `${cloudfrontUrl}/product12.jpg`,
        category: "flowerPot",
        tags: ["Indoor", "Garden"]
    },
    {
        id: 13,
        name: "Mandala Box",
        price: "₹300",
        description: "Exquisite Mandela Art Box for storing your small treasures. Hand-painted patterns make each box a unique piece of corporate or personal gift-ware.",
        image: `${cloudfrontUrl}/product13.jpg`,
        category: "corporateGifts",
        tags: ["Business", "Office Use"]
    },
    {
        id: 14,
        name: "Rope Bowl",
        price: "₹280",
        description: "Artistic Rope Bowl for your desk or table. Its unique texture adds a decorative touch to any room while keeping small items organized.",
        image: `${cloudfrontUrl}/product14.jpg`,
        category: "tableDecor",
        tags: ["Decorative", "Stylish"]
    },
    {
        id: 15,
        name: "Stand of Hearts",
        price: "₹160",
        description: "Elegant flower stand designed to elevate your botanical displays. Its minimalist frame provides a sturdy base while letting your plants take center stage.",
        image: `${cloudfrontUrl}/product15.png`,
        category: "flowerPot",
        tags: ["Indoor", "Garden"]
    },
    {
        id: 16,
        name: "Palm Leaf",
        price: "₹60",
        description: "Nature-inspired Palm Leaf bookmark in a deep green hue. A perfect companion for botanical enthusiasts and eco-conscious readers.",
        image: `${cloudfrontUrl}/product16.png`,
        category: "bookMark",
        tags: ["Light Weight", "Simple"]
    },
    {
        id: 17,
        name: "Daisy Flower + Sakura Flowers (2) - Combo",
        price: "₹70",
        description: "Cheerful Daisy keychain with a double-color injection design. A bright and durable accessory to keep your keys organized and easy to find.",
        image: `${cloudfrontUrl}/product17.jpg`,
        category: "keyChain",
        tags: ["Nature", "Gift"]
    },
    {
        id: 18,
        name: "8X8 Mandala Box",
        price: "₹1200",
        description: "A spacious version of our Mandela Art Box, ideal for larger accessories or as a decorative keepsake for your vanity or mantelpiece.",
        image: `${cloudfrontUrl}/product-18.png`,
        category: "tableDecor",
        tags: ["Decorative", "Stylish"]
    },
    {
        id: 19,
        name: "Infinity Cube",
        price: "₹110",
        description: "The ultimate fidget toy for deep thinkers. This Infinity Cube provides endless tactile feedback, helping you stay focused and calm during long work sessions.",
        image: `${cloudfrontUrl}/product-19.png`,
        category: "corporateGifts",
        tags: ["Business", "Office Use"]
    },
    {
        id: 20,
        name: "Visiting Box Green",
        price: "₹345",
        description: "Sleek professional visiting card holder in a vibrant green finish. Make a lasting first impression with this modern and practical office essential.",
        image: `${cloudfrontUrl}/product20.jpg`,
        category: "corporateGifts",
        tags: ["Business", "Office Use"]
    },
    {
        id: 21,
        name: "Harry Potter Bookmark - HP",
        price: "₹60",
        description: "Set of two colorful Harry Potter bookmarks for the ultimate fan. Share one with a friend or use both to track your journey through the series.",
        image: `${cloudfrontUrl}/product-21.png`,
        category: "bookMark",
        tags: ["Light Weight", "Simple"]
    },
    {
        id: 22,
        name: "Honeycomb Vase",
        price: "₹340",
        description: "Modern geometric flower stand that functions as both a pot and a centerpiece. Designed to showcase succulents or small floral arrangements with style.",
        image: `${cloudfrontUrl}/product-22.png`,
        category: "flowerPot",
        tags: ["Indoor", "Garden"]
    },
    {
        id: 23,
        name: "Santa and snowmen peek left side - Christmas bookmark hueforge",
        price: "₹90",
        description: "Festive Christmas-themed bookmark featuring Santa and snowmen. Bring the holiday spirit to your reading list with this charming festive accessory.",
        image: `${cloudfrontUrl}/product23.jpg`,
        category: "bookMark",
        tags: ["Light Weight", "Simple"]
    },
    {
        id: 24,
        name: "Hello Kitty Pink Bow",
        price: "₹60",
        description: "Adorable Small Hello Kitty keychain, a cute and nostalgic addition to your keys or backpack. Perfect for fans of all ages.",
        image: `${cloudfrontUrl}/product24.jpg`,
        category: "keyChain",
        tags: ["Fan Art", "Gift"]
    },
    {
        id: 25,
        name: "Pen Holder (medium)",
        price: "₹180",
        description: "Industrial Type 6 pen stand, designed for those who appreciate clean lines and functional desk organization. Built to last and highly practical.",
        image: `${cloudfrontUrl}/product25.png`,
        category: "penStand",
        tags: ["Desk Use", "Compact"]
    },
    {
        id: 26,
        name: "Soccer Ball Coaster - 6 Pieces",
        price: "₹250",
        description: "Set of 6 soccer ball-themed coasters. A perfect gift for sports fans or a fun addition to your game room or coffee table.",
        image: `${cloudfrontUrl}/product26.jpg`,
        category: "corporateGifts",
        tags: ["Business", "Office Use"]
    },
    {
        id: 27,
        name: "Twisted Vase",
        price: "₹220",
        description: "Fascinating Twisted Vase with a unique spiral geometry. Designed to create a dynamic visual effect, it's a masterpiece of modern decorative design.",
        image: `${cloudfrontUrl}/product-27.png`,
        category: "flowerPot",
        tags: ["Indoor", "Garden"]
    },
    {
        id: 28,
        name: "Snow Flake Bowl",
        price: "₹230",
        description: "Intricately detailed Snowflake Bowl, perfect for seasonal decor or as a year-round artistic centerpiece for your table.",
        image: `${cloudfrontUrl}/product28.jpg`,
        category: "tableDecor",
        tags: ["Decorative", "Stylish"]
    },
    {
        id: 29,
        name: "Keychain Stand",
        price: "₹180",
        description: "Sturdy and innovative stand designed to keep all your keychains displayed and organized. A practical solution for collectors and enthusiasts.",
        image: `${cloudfrontUrl}/product-29.png`,
        category: "keyChain",
        tags: ["Office", "Practical"]
    },
    {
        id: 30,
        name: "Knitted Bowl",
        price: "₹300",
        description: "Unique 3D-printed bowl with a realistic knitted texture. A charming addition to your coffee table, perfect for yarn enthusiasts or as a cozy decorative piece.",
        image: `${cloudfrontUrl}/product-30.png`,
        category: "tableDecor",
        tags: ["Decorative", "Stylish"]
    },
    {
        id: 31,
        name: "Basket Ball Coaster - 6 Pieces",
        price: "₹250",
        description: "Set of 6 basketball-themed coasters for the sports fan. Protect your surfaces with these durable and fun accessories, ideal for game nights.",
        image: `${cloudfrontUrl}/product-31.png`,
        category: "tableDecor",
        tags: ["Decorative", "Stylish"]
    },
    {
        id: 32,
        name: "Floating Rose (100mm) - Big",
        price: "₹165",
        description: "Large, elegant 3D-printed floating rose. A beautiful water-resistant decorative piece for bowls or as a stunning standalone floral accent.",
        image: `${cloudfrontUrl}/product-32.png`,
        category: "tableDecor",
        tags: ["Decorative", "Stylish"]
    },
    {
        id: 33,
        name: "Rose Stem",
        price: "₹65",
        description: "A long-lasting 3D-printed rose with a detailed stem. Never wilts, making it a perfect eternal gift or an elegant addition to any vase.",
        image: `${cloudfrontUrl}/product-33.png`,
        category: "tableDecor",
        tags: ["Decorative", "Stylish"]
    },
    {
        id: 34,
        name: "Snack Box",
        price: "₹440",
        description: "Functional and stylish snack box for your desk or travel. Keep your treats organized and fresh with this modern geometric storage solution.",
        image: `${cloudfrontUrl}/product-34.png`,
        category: "tableDecor",
        tags: ["Decorative", "Stylish"]
    },
    {
        id: 35,
        name: "Maze Pen Holder (medium)",
        price: "₹220",
        description: "Intricately designed 8x8 cm box featuring a detailed mandala pattern on the lid. Perfect for jewelry, small keepsakes, or as a thoughtful gift.",
        image: `${cloudfrontUrl}/product-35.png`,
        category: "penStand",
        tags: ["Decorative", "Stylish"]
    },
    {
        id: 36,
        name: "Expiral Vase",
        price: "₹600",
        description: "Modern Expiral Vase with a complex spiral design. Its striking geometry makes it a standout decorative piece for any contemporary home or office.",
        image: `${cloudfrontUrl}/product-36.png`,
        category: "flowerPot",
        tags: ["Decorative", "Stylish"]
    },
    {
        id: 37,
        name: "Flow Vase",
        price: "₹600",
        description: "Elegantly curved Flow Vase that mimics the organic movement of water. A sophisticated centerpiece that complements any interior design style.",
        image: `${cloudfrontUrl}/product37.jpg`,
        category: "flowerPot",
        tags: ["Decorative", "Stylish"]
    },
    {
        id: 38,
        name: "Flute Vase",
        price: "₹450",
        description: "Slender and graceful Flute Vase designed for single stems or small arrangements. Its minimalist profile adds a touch of class to your tabletop.",
        image: `${cloudfrontUrl}/product-388.png`,
        category: "flowerPot",
        tags: ["Decorative", "Stylish"]
    },
    {
        id: 39,
        name: "Monstera Keychain",
        price: "₹60",
        description: "Iconic Monstera leaf keychain for nature lovers. A vibrant and stylish accessory to add a touch of botanical flair to your keys or bag.",
        image: `${cloudfrontUrl}/product-39.png`,
        category: "keyChain",
        tags: ["Nature", "Gift"]
    },
    {
        id: 40,
        name: "Diomond Vase",
        price: "₹180",
        description: "Modern Diamond Vase with a crisp geometric silhouette. Its multifaceted surface plays with light and shadow, creating a stunning contemporary display.",
        image: `${cloudfrontUrl}/product-40.png`,
        category: "penStand",
        tags: ["Desk Use", "Compact"]
    },
    {
        id: 41,
        name: "Leaf Pen Stand / Vase",
        price: "₹340",
        description: "Versatile Lead-style container that serves as both a pen stand and a minimalist vase. A clean and functional addition to any creative workspace.",
        image: `${cloudfrontUrl}/product-41.png`,
        category: "penStand",
        tags: ["Desk Use", "Compact"]
    },
    {
        id: 42,
        name: "Small Plant Pot / Vase / PenStand",
        price: "₹220",
        description: "Multi-functional small pot designed for plants, flowers, or stationery. Its compact and sturdy design makes it a perfect all-rounder for your desk.",
        image: `${cloudfrontUrl}/product42.png`,
        category: "flowerPot",
        tags: ["Indoor", "Garden"]
    },
    {
        id: 43,
        name: "Cinnamaroll Keychain",
        price: "₹70",
        description: "Adorable Cinnamaroll keychain, a sweet and charming accessory for fans of the beloved character. Durable and perfect for everyday use.",
        image: `${cloudfrontUrl}/product-43.png`,
        category: "keyChain",
        tags: ["Fan Art", "Gift"]
    },
    {
        id: 44,
        name: "Mini Expiral Pitcher",
        price: "₹100",
        description: "Intriguing Maze-patterned pen holder that adds a puzzle-like aesthetic to your desk. Keep your pens organized in this unique and artistic container.",
        image: `${cloudfrontUrl}/product-44.png`,
        category: "flowerPot",
        tags: ["Indoor", "Garden"]
    },
    {
        id: 45,
        name: "Coaster1 - No Stand",
        price: "₹58",
        description: "Sleek and minimalist individual coaster designed to protect your furniture with style. A simple yet effective accessory for any modern home.",
        image: `${cloudfrontUrl}/product45.png`,
        category: "tableDecor",
        tags: ["Decorative", "Stylish"]
    },
    {
        id: 46,
        name: "Sixteenth note+ Treble Clef set",
        price: "₹55",
        description: "Musical-themed table decor set featuring a sixteenth note and a treble clef. A harmonious gift for musicians and music enthusiasts.",
        image: `${cloudfrontUrl}/product-46.png`,
        category: "tableDecor",
        tags: ["Decorative", "Stylish"]
    },
    {
        id: 47,
        name: "Hexagon Fidget Keychain",
        price: "₹80",
        description: "Satisfying Hexagon-shaped fidget keychain for on-the-go stress relief. Compact, tactile, and designed to keep your hands busy wherever you are.",
        image: `${cloudfrontUrl}/product-47.png`,
        category: "keyChain",
        tags: ["Gift", "Practical"]
    },
    {
        id: 48,
        name: "Teddy Keychain",
        price: "₹40",
        description: "Cute and cuddly 3D-printed Teddy keychain. A sweet companion for your keys or a thoughtful small gift for someone special.",
        image: `${cloudfrontUrl}/product-48.png`,
        category: "keyChain",
        tags: ["Gift", "Decorative"]
    },
    {
        id: 49,
        name: "Gyro Keychain",
        price: "₹65",
        description: "Fascinating spinning gyro keychain that provides a satisfying tactile experience. A perfect pocket-sized fidget tool for stress relief.",
        image: `${cloudfrontUrl}/product-49.png`,
        category: "keyChain",
        tags: ["Fidget", "Practical"]
    },
    {
        id: 50,
        name: "Sensory Star Fidget",
        price: "₹130",
        description: "Tactile star-shaped fidget toy designed for sensory stimulation and focus. An excellent corporate gift for modern workspaces.",
        image: `${cloudfrontUrl}/product-50.png`,
        category: "corporateGifts",
        tags: ["Business", "Office Use"]
    },
    {
        id: 51,
        name: "Knitted Heart Keychain",
        price: "₹80",
        description: "Sweet 3D-printed heart with a realistic 'knitted' texture. A unique and lightweight gift to show your love.",
        image: `${cloudfrontUrl}/productk51.png`,
        category: "keyChain",
        tags: ["Gift", "Decorative"]
    },
    {
        id: 52,
        name: "Music Note + Sixteenth Note Set",
        price: "₹55",
        description: "Elegant set of musical note keychains, including a treble clef and sixteenth note. Perfect for musicians and music teachers.",
        image: `${cloudfrontUrl}/product-52.png`,
        category: "keyChain",
        tags: ["Music", "Gift"]
    },
    {
        id: 53,
        name: "Bunny",
        price: "₹135",
        description: "Adorable minimalist bunny figurine with smooth lines. A charming decorative piece for your shelf, desk, or nursery.",
        image: `${cloudfrontUrl}/product-53.png`,
        category: "tableDecor",
        tags: ["Decorative", "Stylish"]
    },
    {
        id: 54,
        name: "Tissue Box",
        price: "₹420",
        description: "Modern geometric tissue box holder that turns a household essential into a piece of art. Durable and easy to refill.",
        image: `${cloudfrontUrl}/product54.jpg`,
        category: "corporateGifts",
        tags: ["Business", "Office Use"]
    },
    {
        id: 55,
        name: "Pentagon Fidget Keychain",
        price: "₹80",
        description: "Geometric pentagon-shaped fidget keychain for tactile focus. A cool and modern addition to your everyday carry.",
        image: `${cloudfrontUrl}/product-55.png`,
        category: "keyChain",
        tags: ["Gift", "Practical"]
    },
    {
        id: 56,
        name: "Hello Kitty Red Bow",
        price: "₹70",
        description: "Adorable Hello Kitty keychain featuring her signature red bow. A sweet and nostalgic gift for Sanrio fans.",
        image: `${cloudfrontUrl}/product-56.png`,
        category: "keyChain",
        tags: ["Fan Art", "Gift"]
    },
    {
        id: 57,
        name: "Small Star Keychain",
        price: "₹40",
        description: "Simple and cute small star keychain. A lightweight accessory to brighten up your keys or zipper pulls.",
        image: `${cloudfrontUrl}/product-57.png`,
        category: "keyChain",
        tags: ["Gift", "Decorative"]
    },
    {
        id: 58,
        name: "Big Star Keychain",
        price: "₹125",
        description: "Bold 3D-printed big star keychain. Makes your keys easy to find and adds a cosmic touch to your bag.",
        image: `${cloudfrontUrl}/product58.jpg`,
        category: "keyChain",
        tags: ["Gift", "Decorative"]
    },
    {
        id: 59,
        name: "Fairy Bookmark Single Color",
        price: "₹60",
        description: "Charming single-color fairy bookmark. Its slender design slips perfectly between pages, keeping your place with a touch of magic.",
        image: `${cloudfrontUrl}/product-59.png`,
        category: "bookMark",
        tags: ["Light Weight", "Simple"]
    },
    {
        id: 60,
        name: "Dragonfly Bookmark",
        price: "₹65",
        description: "Delicate dragonfly-shaped bookmark with intricate wing details. An elegant accessory for nature-loving readers.",
        image: `${cloudfrontUrl}/product-60.png`,
        category: "bookMark",
        tags: ["Light Weight", "Simple"]
    },
    {
        id: 61,
        name: "Jothi Software Keychains",
        price: "₹50",
        description: "Custom corporate keychains designed for professional branding. Sturdy and practical for office use and promotional gifts.",
        image: `${cloudfrontUrl}/product-61.png`,
        category: "corporateGifts",
        tags: ["Business", "Office Use"]
    },
    {
        id: 62,
        name: "Flower Bookmark",
        price: "₹40",
        description: "Simple and cheerful flower bookmark. A small, vibrant gift that adds a floral touch to any reading session.",
        image: `${cloudfrontUrl}/product-62.png`,
        category: "bookMark",
        tags: ["Light Weight", "Simple"]
    },
    {
        id: 63,
        name: "Ribbed Pencil Holder",
        price: "₹110",
        description: "Modern pen stand with a classic ribbed texture. Keeps your pens, pencils, and styluses neatly organized on your desk.",
        image: `${cloudfrontUrl}/product63.png`,
        category: "penStand",
        tags: ["Desk Use", "Compact"]
    },
    {
        id: 64,
        name: "Christmas Bookmarks - Gingerbread Reading Hueforge",
        price: "₹90",
        description: "Charming gingerbread-themed bookmark. A sweet way to mark your holiday reading progress.",
        image: `${cloudfrontUrl}/product64.jpg`,
        category: "bookMark",
        tags: ["Light Weight", "Simple"]
    },
    {
        id: 65,
        name: "Santa and Snowman Christmas Bookmark",
        price: "₹90",
        description: "Festive bookmark featuring Santa and a snowman. Durable and vibrant, perfect for winter reading.",
        image: `${cloudfrontUrl}/product65.jpg`,
        category: "bookMark",
        tags: ["Light Weight", "Simple"]
    },
    {
        id: 66,
        name: "Twisted Tea Candle",
        price: "₹80",
        description: "Unique twisted design for tea light candles. Adds a warm, modern glow to your dining table or living space.",
        image: `${cloudfrontUrl}/product66.png`,
        category: "tableDecor",
        tags: ["Decorative", "Stylish"]
    },
    {
        id: 67,
        name: "Pebble Tea Light Holder",
        price: "₹85",
        description: "Organic pebble-shaped tea light holder. Its natural silhouette creates a serene and cozy atmosphere.",
        image: `${cloudfrontUrl}/product-67.png`,
        category: "tableDecor",
        tags: ["Decorative", "Stylish"]
    },
    {
        id: 68,
        name: "Elena/Modli Keychain",
        price: "₹60",
        description: "Signature Modli branded keychain. Sleek and professional, a perfect accessory for branding enthusiasts.",
        image: `${cloudfrontUrl}/product-68.png`,
        category: "keyChain",
        tags: ["Brand", "Practical"]
    },
    {
        id: 69,
        name: "Katherine Model 1",
        price: "₹50",
        description: "Magic-inspired phone stand for hands-free viewing. Sturdy enough to hold most smartphones securely.",
        image: `${cloudfrontUrl}/product-69.png`,
        category: "tableDecor",
        tags: ["Decorative", "Stylish"]
    },
    {
        id: 70,
        name: "Katherine Double Color",
        price: "₹60",
        description: "Small decorative pitcher with an expiral texture. Perfect for accenting your kitchen or desk as a tiny flower holder.",
        image: `${cloudfrontUrl}/product70.png`,
        category: "keyChain",
        tags: ["Decorative", "Creative"]
    },
    {
        id: 71,
        name: "Letter A (Lego Style)",
        price: "₹55",
        description: "Classic Greek-inspired pen stand. Adds an historical and artistic flair to your stationery organization.",
        image: `${cloudfrontUrl}/product-71.png`,
        category: "keyChain",
        tags: ["Artistic", "Practical"]
    },
    {
        id: 72,
        name: "Letter B (Lego Style)",
        price: "₹55",
        description: "Sturdy single-color keychain with a modern design. Durable and light, it's a perfect accessory for your car or home keys.",
        image: `${cloudfrontUrl}/product-72.png`,
        category: "keyChain",
        tags: ["Gift", "Practical"]
    },
    {
        id: 73,
        name: "Letter C (Lego Style)",
        price: "₹55",
        description: "Vibrant double-color keychain for a stylish look. Made with premium materials to ensure long-lasting use.",
        image: `${cloudfrontUrl}/product-73.png`,
        category: "keyChain",
        tags: ["Gift", "Practical"]
    },
    {
        id: 74,
        name: "Harry Potter BookMark - Glasses",
        price: "₹60",
        description: "Fun Lego-style 'A' keychain. A playful way to personalize your belongings with your initial.",
        image: `${cloudfrontUrl}/product-74.png`,
        category: "bookMark",
        tags: ["Light Weight", "Simple"]
    }
    // {
    //     id: 75,
    //     name: "Greek Pen Stand",
    //     price: "₹220",
    //     description: "Fun Lego-style 'A' keychain. A playful way to personalize your belongings with your initial.",
    //     image: `${cloudfrontUrl}/emtyProduct.jpg`,
    //     category: "tableDecor",
    //     tags: ["Decorative", "Stylish"]
    // },
    // {
    //     id: 76,
    //     name: "Harry Potter Phone Stand",
    //     price: "₹160",
    //     description: "Fun Lego-style 'B' keychain. A playful way to personalize your belongings with your initial.",
    //     image: `${cloudfrontUrl}/emtyProduct.jpg`,
    //     category: "tableDecor",
    //     tags: ["Decorative", "Stylish"]
    // }
];
